import SocialLinkComponent from "./Component";

function SocialLinks({ details}) {

  return <SocialLinkComponent details={details} />;
}

export default SocialLinks;
